'use es6';

import { upgradeProductToMerchIds } from 'self-service-api/constants/Trials';
import { buildTrialState } from 'self-service-api/core/utilities/trialUtils';
import { TEMPORARY_REMOTE_TOOLS } from 'self-service-api/constants/UpgradeProducts';
export var trialStateAdapter = function trialStateAdapter(trialState) {
  if (trialState.length === 0) return trialState;
  var transformedTrialState = {};
  trialState.forEach(function (hubTrial) {
    var trials = hubTrial.trials,
        createdAt = hubTrial.createdAt,
        endsAt = hubTrial.endsAt,
        removedAt = hubTrial.removedAt;
    trials.forEach(function (trial) {
      var name = trial.name,
          id = trial.id; //Temporary since covid remote tools trial does not have a merch id

      var label;

      if (name === 'temp-covid-relief-trial') {
        label = TEMPORARY_REMOTE_TOOLS;
      } else {
        label = upgradeProductToMerchIds[name];
      }

      transformedTrialState[label] = buildTrialState(createdAt, endsAt, removedAt, id);
    });
  });
  return transformedTrialState;
};